import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  summaryView: boolean;
}

const initialState: StateInterface = {
  summaryView: true
};

export const paymentCardViewReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.OPEN_PAYMENT_CARD_ON_DETAILED_VIEW:
      return {
        summaryView: false
      };

    case Constants.RESET_PAYMENT_CARD_ON_DETAILED_VIEW:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
